<template>
  <div>
    <h2>HEENT</h2>
    <v-container v-if="!loading" class="py-10">
      <v-row>
        <v-col
          v-for="item in heent"
          class="shrink my-0 py-0"
          cols="12"
          md="4"
          :key="item.id"
        >
          <v-checkbox
            v-model="heentCheckbox"
            :disabled="disableHeent(item.id, item.is_normal)"
            :label="item.name"
            :value="item.id"
            hide-details
            @change="(toggle) => heentTick(item.id, toggle, item.is_normal)"
          />
        </v-col>
      </v-row>
      <v-row v-if="isHeentRemark">
        <v-col>
          <v-text-field
            placeholder="Other"
            outlined
            v-model="heent_remark"
            :rules="[(v) => !!v || 'HEENT Other is required']"
            label="HEENT Other"
            @keyup="includeHeentRemark"
            required
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else style="text-align: center">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
        >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Heent",

  props: {
    formData: {
      type: Object,
      required: true,
    },
    config: Number,
  },

  data() {
    return {
      isHeentRemark: false,
      heent_remark: null,
      isHeentNormal: false,
      loading: true,
      heent: {},
      heentCheckbox: [],
    };
  },

  methods: {
    editFieldHeent() {
      let vm = this;
      _.forEach(this.formData.physical_examination.heent, function (value) {
        vm.heentCheckbox.push(Number.parseInt(value.heent_id));
        if (value.heent_remark) {
          vm.heent_remark = value.heent_remark;
          vm.isHeentRemark = true;
        }
      });
    },

    disableHeent(id, normal = 0, toggle = true) {
      let vm = this;
      _.forEach(this.formData.physical_examination.heent, function (value) {
        if (
          Number.parseInt(value.heent_id) === Number.parseInt(id) &&
          normal &&
          toggle
        ) {
          vm.isHeentNormal = true;
        }
      });
      return this.heentCheckbox.indexOf(id) === -1 && this.isHeentNormal;
    },

    heentTick(key, toggle, is_normal) {
      let toggled = toggle.includes(Number.parseInt(key));
      let heent = this.formData.physical_examination.heent;

      if (key === this.config) {
        this.isHeentRemark = !this.isHeentRemark;
      }
      if (is_normal) {
        this.isHeentNormal = !this.isHeentNormal;
        this.heentNormalOnly(key, toggled);
        this.disableHeent(key, is_normal, toggled);
      }

      if (toggled) {
        heent.push({
          heent_id: key,
          heent_remark: null,
        });
      } else {
        let index = heent.findIndex((heent) => heent.heent_id === key);
        heent.splice(index, 1);
      }
    },

    heentNormalOnly(key, toggled) {
      if (toggled) {
        let heent = this.formData.physical_examination.heent;
        heent.push({
          heent_id: key,
          heent_remark: null,
        });
        this.heentCheckbox = [key];
        heent.splice(0, heent.length);
        this.isHeentRemark = false;
      }
    },

    includeHeentRemark() {
      let heent = this.formData.physical_examination.heent;
      let index = heent.findIndex((heent) => heent.heent_id === this.config);
      heent.splice(index, 1);
      heent.push({
        heent_id: this.config,
        heent_remark: this.heent_remark,
      });
    },

    getHeentLib() {
      this.axios
        .get("heent-lib", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN"),
          },
        })
        .then((response) => {
          this.heent = response.data;
          this.loading = false;
        })
        .catch((error) => {
          // handle error
          console.error(error);
        })
        .finally(() => {
          // always executed
        });
    },
  },

  mounted() {
    this.getHeentLib();
    this.editFieldHeent();
  },
};
</script>

<style scoped>
</style>